import React from "react";

import { Checkbox as CheckboxMUI } from "@mui/material";

import { ICheckbox } from "./interface";

const colors = {
  default_blue: "#1976d2",
};

export const Checkbox: React.FC<ICheckbox> = ({
  id,
  checked,
  disabled = false,
  onChange,
}) => {
  return (
    <CheckboxMUI
      id={id}
      data-testid={id}
      checked={checked}
      sx={{
        color: "#cbcbcb",
        "&.Mui-checked": {
          color: colors.default_blue,
        },
        "&.Mui-disabled": {
          color: "#d1dbe3",
        },
      }}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
